import { isTouch } from 'Lib/istouch/istouch';

const sNote = '.note';
const $note = $(sNote);
const sClose = '.note__close';
const cActive = 'note_active';
const sPopup = '.note__popup';
const popupHTML = '<span class="note__popup">{words}<span class="note__close"></span></span>';
const offsetTop = 13;

function showNote($n) {
    if ($n.length) {
        const text = $n.data('text');

        hideNote();
        $n.addClass(cActive);

        if (text.length && $n.hasClass(cActive)) {
            if (!$n.find(sPopup).length) {
                $n.append(popupHTML.replace('{words}', text));
            }

            $n.find(sPopup).css({ 'top': $n.position().top - $n.find(sPopup).outerHeight() - offsetTop });
        }
    }
}

function hideNote() {
    $note.removeClass(cActive);
}

$note.on('click', function (e) {
    e.preventDefault();

    if (isTouch()) {
        if ($(e.target).is(sNote)) {
            showNote($(this));
        } else if ($(e.target).is(sClose)) {
            hideNote();
        }
    }
});

$note.on('mouseenter', function () {
    if (!isTouch()) {
        showNote($(this));
    }
});

$note.on('mouseleave', () => {
    if (!isTouch()) {
        hideNote();
    }
});

$(document).on('click', (e) => {
    if (isTouch()) {
        if ($(e.target).closest(sNote).length || $(e.target).is(sNote)) {
            return;
        }

        hideNote();
        e.stopPropagation();
    }
});